import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MenuItem, Form, Col, Row, ControlLabel } from 'react-bootstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { CheckboxGroup, TextField } from '../ReduxFormField';

import { Button, DatePicker, Icon, Modal } from '../../../common/components';
import { closeModal, openModal } from '../Modal/ModalRedux';
import { createMultipleNotes, createNote } from './noteActions';
import UploadModalComponent from '../Upload/UploadModal';
import { clearFiles, removeFile } from '../Upload/UploadRedux';
import { get, map, set, flow } from 'lodash';
import './styles.scss';
import {
  getBrokerId,
  getOrganisationId,
  isBroker,
} from '../../../modules/auth/redux/authActions';

const FORM_NAME = 'createNoteForm';

const validate = (values) => {
  const errors = {};

  if (!get(values, 'data.attributes.content', false)) {
    set(errors, 'data.attributes.content', 'Required');
  }
  return errors;
};

class CreateNoteButton extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    notableResource: PropTypes.object.isRequired,
    notableResourceType: PropTypes.string.isRequired,
    callback: PropTypes.func,
    label: PropTypes.string,
    menuItem: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleUploadComplete = this.handleUploadComplete.bind(this);
    this.state = {
      hasReminder: false,
    };
  }

  resetState = () => {
    const { actions } = this.props;
    actions.clearFiles();
  };

  componentWillUpdate(newProps) {
    const { dispatch, callback, notes, name } = this.props;
    if (
      !newProps.notes.isSubmitting &&
      newProps.notes.isSubmitting !== notes.isSubmitting
    ) {
      if (callback) {
        callback();
      }
      dispatch(closeModal(name));
      this.resetState();
    }
  }

  handleSubmit(values) {
    const { files, multipleNotes, multipleIdsString } = this.props;
    if (files.length) {
      values.data.relationships = {
        attachments: {
          data: files.map((file) => {
            return {
              id: file.id,
              type: file.type,
            };
          }),
        },
      };
    }

    const multiPayload = (values) => {
      return {
        data: map(this.props.notableResource.multi, (resource) => {
          return {
            id: resource.id,
            ...values,
          };
        }),
      };
    };

    const splitNotableResource = (values) => {
      // const _idsToArray = this.props.notableResource.data.id.split(',');
      const ids = this.props?.notableResource?.data?.id;

      return ids?.map((id) => ({
        id: id,
        ...values,
      }));
    };

    const payload = multipleNotes ? multiPayload(values) : values;
    const payloadMulti = multipleIdsString
      ? { data: splitNotableResource(values) }
      : null;
    if (multipleIdsString) {
      return this.props.dispatch(
        createMultipleNotes(payloadMulti, this.props.notableResourceType),
      );
    }

    if (multipleNotes) {
      return this.props.dispatch(
        createMultipleNotes(
          payload,
          this.props.notableResource,
          this.props.notableResourceType,
        ),
      );
    } else {
      return this.props.dispatch(
        createNote(payload, this.props.notableResource, this.props.notableResourceType),
      );
    }
  }

  handleOpenCreateNoteButton = () => {
    const { dispatch, reset, change, defaultText, name } = this.props;

    dispatch(reset());
    dispatch(change('data.attributes.forward_url', get(location, 'pathname', null)));
    dispatch(change('data.attributes.content', defaultText));
    dispatch(openModal(name));
  };

  handleUpload() {
    const { dispatch, name } = this.props;
    dispatch(openModal(`UploadModal${name}`));
  }

  handleUploadComplete() {
    //
  }

  render() {
    const {
      label,
      handleSubmit,
      submitting,
      formValues,
      menuItem,
      name,
      modals,
    } = this.props;
    const title = label || 'Create Note';

    const modalFooter = (
      <div>
        <Button
          type="submit"
          bsStyle="primary"
          className="pull-right"
          isLoading={submitting}
          handleClick={handleSubmit(this.handleSubmit)}
          label="Create Note"
        />
        {!menuItem && (
          <Button
            type="button"
            bsStyle="primary"
            className="pull-right pad-right"
            handleClick={this.handleUpload}
          >
            {submitting ? (
              <i className="fa fa-cog fa-spin" />
            ) : (
              <i className="fa fa-upload" />
            )}{' '}
            upload attachment
          </Button>
        )}
      </div>
    );

    const modal = (
      <div>
        <Modal
          name={name}
          title={title}
          close
          onHide={this.resetState}
          footer={modalFooter}
        >
          {modals[name] && modals[name].visible && (
            <Form onSubmit={handleSubmit(this.handleSubmit)}>
              <div className="create-note-btn">
                <Row>
                  <Col sm={12}>
                    <ControlLabel className="note-label filter-label">
                      Add your notes
                    </ControlLabel>
                    <Field
                      name={'data.attributes.content'}
                      labelSize={3}
                      type="textarea"
                      component={TextField}
                    />
                  </Col>
                </Row>
                {!menuItem && (
                  <Row>
                    <Col sm={5} className="set-reminder-text">
                      <Field
                        name={'meta.set_reminder'}
                        inline
                        options={[{ label: 'Set a reminder', value: true }]}
                        labelSize={2}
                        component={CheckboxGroup}
                      />
                    </Col>
                    <Col sm={6} className="set-reminder-text">
                      {get(formValues, 'meta.set_reminder') && (
                        <Field
                          name={'data.attributes.reminder'}
                          label="Remind me on"
                          block
                          labelSize={5}
                          component={DatePicker}
                          minDateToday={true}
                          shouldCloseOnSelect={false}
                        />
                      )}
                    </Col>
                  </Row>
                )}
                {this.props.files.length ? this.renderUploads() : null}
              </div>
            </Form>
          )}
        </Modal>
        <UploadModalComponent
          modalIdentifier={`UploadModal${name}`}
          onComplete={this.handleUploadComplete}
        />
      </div>
    );

    if (menuItem) {
      return (
        <MenuItem eventKey="3">
          <span onClick={() => this.handleOpenCreateNoteButton()}>
            <Icon name="sticky-note-o" /> Add Note
          </span>
          {modal}
        </MenuItem>
      );
    }

    return (
      <div className="note-btn-wrapper">
        <Button
          bsStyle="primary"
          {...this.props}
          label={title}
          handleClick={() => this.handleOpenCreateNoteButton()}
        />
        {modal}
      </div>
    );
  }

  renderUploads() {
    const { files, actions } = this.props;

    return (
      <Row>
        <Col sm={12}>
          <ControlLabel>Attachments:</ControlLabel>
          <ul className="upload-list">
            {files.map((file, i) => {
              return (
                <li key={i}>
                  <div className="upload-progress" style={{ width: '100%' }} />
                  <a onClick={() => actions.removeFile(i)}>
                    <i className="fa fa-times" />
                  </a>
                  <div className="content">
                    <p className="pull-right">&nbsp;</p> {file.attributes.name}
                  </div>
                </li>
              );
            })}
          </ul>
        </Col>
      </Row>
    );
  }
}

export default flow([
  reduxForm({
    form: FORM_NAME,
    validate,
  }),
  connect(
    (state, props) => {
      const getInitialValues = () => {
        return {
          data: {
            attributes: {
              content: '',
              forward_url: '',
              share: isBroker() ? 'broker' : 'organisation',
              share_id: isBroker() ? getBrokerId() : getOrganisationId(),
            },
          },
        };
      };
      return {
        formValues: getFormValues(FORM_NAME)(state),
        initialValues: getInitialValues(props.notableResourceType),
        files: state.upload.files,
        modals: state.modal.modals,
        notes: state.notes,
      };
    },
    (dispatch) => {
      return {
        actions: bindActionCreators({ clearFiles, removeFile }, dispatch),
        dispatch,
      };
    },
  ),
])(CreateNoteButton);
